module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figA02_profile-zone-based-evaluation-tip-root.aac7b520.png";